export const MOVEMENT_ATP_COST_PER_SECOND = 0.7;
export const NATURAL_ATP_REGEN_PER_SECOND = 0.2;
export const MOVING_REGEN_MULTIPLIER = 0.5;

export const MITOCHONDRIA_GLUCOSE_PER_SECOND = 0.1;
export const MITOCHONDRIA_ATP_PER_SECOND = 1;
export const MITOCHONDRIA_ATP_CAPACITY_BONUS = 5;

export const BASE_CELL_RADIUS = 100;
export const RESOURCE_COLLECTION_MARGIN = 15;
export const RESOURCE_CLICK_RADIUS = 10;

export const TOXIN_SPEED = 200;
export const TOXIN_LIFETIME_MS = 2000;
export const TOXIN_DEFAULT_DAMAGE = 10;
export const TOXIN_ATP_COST = 2;

export const WORLD_SIZE = 5000;

const MEMBRANE_STAGE_MULTIPLIER: Record<number, number> = {
  1: 1.0,
  2: 1.15,
  3: 1.3,
  4: 1.5
};

export function getMembraneSizeMultiplier(stage: number): number {
  return MEMBRANE_STAGE_MULTIPLIER[stage] ?? MEMBRANE_STAGE_MULTIPLIER[1];
}

export function getResourceCollectionRadius(stage: number): number {
  return BASE_CELL_RADIUS * getMembraneSizeMultiplier(stage) + RESOURCE_COLLECTION_MARGIN;
}
